import React from "react";
import Blog from "../sections/Blog.jsx";
export default function PageBlog() { return <Blog />; }
